import {
  DOMAIN_ONSHIP, DOMAIN_ONSHIP_STAGE, DOMAIN_PIVOTEL, DOMAIN_STATIONSATCOM,INTELSAT, ONECARE, ONECARE_LANDING, ONECARE_PROD_URL,
  ONECARE_PROD_URL_NEW, ONECARE_STAGE_URL, ONSHIP_LANDING, ONSHIP_NEW_STAGE2_URL, ONSHIP_PROD_URL, ONSHIP_STAGE_URL, PIVOTEL_LANDING, PIVOTEL_PROD_URL, PIVOTEL_STAGE_URL, SIGMA, SIGMA_LANDING,
  STAGE_8_THURAYA_URL,
  STATIONSATCOM, STATIONSATCOM_PROD_URL, STATION_ONE, STATION_ONE_LANDING, STATION_ONE_URL, STATION_SATCOM_LANDING, INTELSAT_STAGE_URL, INTELSAT_PROD_URL, INTELSAT_LANDING, THURAYA_DOMAIN, THURAYA_LANDING, THURAYA_STAGE_URL, THURAYA_T2M_PROD_URL, VIKAND,
  VIKAND_CONNECT_PROD_URL,
  VIKAND_DIRECT_LANDING, VIKAND_LANDING, VIKAND_NEW_STAGE_URL, VIKAND_PROD_URL, VIKAND_STAGE_URL,STATION_ONE_STAGE_URL,
  THURAYA_PROD_URL,
  ISLE_OF_MAN_LANDING,
  ISLE_OF_MAN,
  ISLE_OF_MAN_PROD_URL,
  ISLE_OF_MAN_STAGE_URL,
  ONECARE_PROD_URL_NEW_V2} from './Constants';

const { getSignupPath } = require('../Services/StorageService');

let landingPath = window.location.pathname;

if (landingPath === '/verify' || landingPath.includes('/app')) {
  if (getSignupPath()) {
    landingPath = getSignupPath();
  }
}

let currentClient = null;

const apiChangeArray = [
  { path: VIKAND_LANDING, appType: VIKAND },
  { path: VIKAND_DIRECT_LANDING, appType: VIKAND },
  { path: THURAYA_LANDING, appType: THURAYA_DOMAIN },
  { path: ONSHIP_LANDING, appType: DOMAIN_ONSHIP },
  { path: ISLE_OF_MAN_LANDING, appType: ISLE_OF_MAN },
  { path: ONECARE_LANDING, appType: ONECARE },
  { path: STATION_SATCOM_LANDING, appType: STATIONSATCOM },
  { path: INTELSAT_LANDING, appType: INTELSAT },
  { path: STATION_ONE_LANDING, appType: STATION_ONE },
  { path: SIGMA_LANDING, appType: SIGMA },
  { path: PIVOTEL_LANDING, appType: DOMAIN_PIVOTEL },
  { path: '/', appType: null },
];

let getIndex = null;

if (landingPath) {
  getIndex = apiChangeArray.findIndex((elem) => elem.path === landingPath);
}

if (getIndex !== null && getIndex !== -1) {
  currentClient = apiChangeArray[getIndex].appType;
}

const https = 'https://';

if ([https + ONSHIP_PROD_URL, https + ONSHIP_STAGE_URL, https + ONSHIP_NEW_STAGE2_URL].includes(window.location.origin)) {
  if([DOMAIN_ONSHIP, DOMAIN_ONSHIP_STAGE].includes(window.location.pathname)) {
    currentClient = DOMAIN_ONSHIP;
  } else if([VIKAND].includes(window.location.pathname)) {
    currentClient = VIKAND;
  }
}
// Reminder: DNS will change
if ([https + VIKAND_PROD_URL, https + VIKAND_STAGE_URL,https + VIKAND_NEW_STAGE_URL, https + VIKAND_CONNECT_PROD_URL].includes(window.location.origin) || [VIKAND].includes(window.location.pathname)) {
  currentClient = VIKAND;
}

if ([https + THURAYA_T2M_PROD_URL, https + THURAYA_STAGE_URL, https + STAGE_8_THURAYA_URL, https + THURAYA_PROD_URL].includes(window.location.origin)
  || [THURAYA_DOMAIN].includes(window.location.pathname)) {
  currentClient = THURAYA_DOMAIN;
}

if ([https + ONECARE_PROD_URL, https + ONECARE_STAGE_URL,https + ONECARE_PROD_URL_NEW, https + ONECARE_PROD_URL_NEW_V2].includes(window.location.origin) || [ONECARE].includes(window.location.pathname)) {
  currentClient = ONECARE;
}

if ([https + STATIONSATCOM_PROD_URL].includes(window.location.origin) || [DOMAIN_STATIONSATCOM].includes(window.location.pathname)) {
  currentClient = STATIONSATCOM;
}

if ([https + STATION_ONE_URL, https + STATION_ONE_STAGE_URL].includes(window.location.origin)) {
  currentClient = STATION_ONE;
}

if ([https + INTELSAT_PROD_URL, https + INTELSAT_STAGE_URL].includes(window.location.origin) || [INTELSAT].includes(window.location.pathname)) {
  currentClient = INTELSAT;
}

if ([https + PIVOTEL_PROD_URL, https + PIVOTEL_STAGE_URL].includes(window.location.origin) || [DOMAIN_PIVOTEL].includes(window.location.pathname)) {
  currentClient = DOMAIN_PIVOTEL;
}

if ([https + ISLE_OF_MAN_PROD_URL, https + ISLE_OF_MAN_STAGE_URL].includes(window.location.origin) || [ISLE_OF_MAN].includes(window.location.pathname)) {
  currentClient = ISLE_OF_MAN;
}

const appType = currentClient;

export default appType;
